import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SecurityContext,
} from '@angular/core';
import {
  MatDatepickerInputEvent,
} from '@angular/material/datepicker';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {constantStrings } from '@shared/helpers/constants';
import { INITIAL_MODAL_STATE, Modal } from '@shared/models';
import { AuditLogExportDate } from '@shared/models/user.model';
import { Subject } from 'rxjs';
import { CasedashboardService } from '../casedashboard.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '@shared/services/auth.service';

@Component({
  selector: 'app-auditlogdate',
  templateUrl: './auditlogdate.component.html',
  styleUrls: ['./auditlogdate.component.scss'],
})
export class AuditlogdateComponent implements OnInit {
  isDisabled = false;
  downloadFlag: boolean = false;
  auditlogDateExportObject: AuditLogExportDate;

  @Input() modal: Modal = INITIAL_MODAL_STATE;
  itemSelected: string;
  startDatePicker = new Subject<MatDatepickerInputEvent<any>>();
  endDatePicker = new Subject<MatDatepickerInputEvent<any>>();
  public today: Date = new Date();
  public maxDate: Object = new Date(this.today);
  startDate: '';
  endDate: '';

  @Output() event = new EventEmitter<any>();
  public showStartDate: boolean = false;
  public showEndDate: boolean = false;
  selectedStart = new Date(this.today);
  selectedEnd = new Date(this.today);
  minDate: Date;
  chosenDateFlag: boolean = false;
  errorAuditLog: string;

  constructor(
    public dialogRef: MatDialogRef<AuditlogdateComponent>,
    private casedashboardService: CasedashboardService,
    private translate: TranslateService,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.toggle('startDate');
    this.isDisabled = true;
    if (this.selectedEnd) this.minDate = new Date(this.today);
  }
  /**
   * The function handles the selection of a date and updates the minimum and maximum dates based on the
   * selected start and end dates.
   */
  dateChosen(event, key) {
    let eventPath = event.srcElement.className;
    let chosenDate = event.srcElement.innerHTML;

    if (this.selectedStart && this.selectedEnd) {
      this.isDisabled = true;
    }

    if (this.selectedEnd) this.maxDate = this.selectedEnd;
    if (
      chosenDate >= 1 &&
      chosenDate <= 31 &&
      (eventPath.includes(
        'mat-calendar-body-cell-content mat-focus-indicator mat-calendar-body-selected'
      ) ||
        eventPath.includes(
          'mat-calendar-body-cell-content mat-focus-indicator mat-calendar-body-today mat-calendar-body-selected'
        ))
    ) {
      this.chosenDateFlag = true;
    } else {
      this.chosenDateFlag = false;
    }
    if (
      key == constantStrings.STARTDATE &&
      this.selectedStart &&
      this.chosenDateFlag
    ) {
      this.minDate = this.selectedStart;
    }
  }
  /**
   * The function toggles between showing the start date and end date based on the input ID.
   */
  toggle(id) {
    if (id == constantStrings.STARTDATE) {
      this.showStartDate = true;
      this.showEndDate = false;
    } else if (id == constantStrings.ENDDATE) {
      this.showEndDate = true;
      this.showStartDate = false;
    }
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  /**
   * The function exports audit logs data as a CSV file.
   */
  public auditLogDateExportAPI(params): any {
    this.casedashboardService.getExportAuditLogsDateService(params).subscribe({
      next: (fileInfo) => {
        if(fileInfo.statusCode === 204){
          this.authService.showAPIErrorMsg(fileInfo.message);
        } else {
          const totalSize = fileInfo.fileSize;
          const chunkSize = 9 * 1024 * 1024;
          const ranges : any = [];
          
          for (let start = 0; start < totalSize; start += chunkSize) {
              const end = Math.min(start + chunkSize - 1, totalSize - 1);
              ranges.push({start,end});
          }
          
          this.casedashboardService.getDownloadAuditLogsDateService(fileInfo.auditLogFileName, ranges).subscribe((responses:any) => {
            const blob = new Blob(responses, { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, url) as string;
            const a = document.createElement('a');
            a.setAttribute('href', sanitizedUrl);
            a.setAttribute('download', fileInfo.auditLogFileName);
            // veracode-scan-ignore
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
        }
      },
      error: (error) => {
        this.errorAuditLog = error;
      },
    });
  }
  /**
   * The function downloads an audit log date export object and closes a dialog reference.
   */
  download() {
    const auditlogDateExportObject = {
      selectedStart: this.casedashboardService.newFormatedDate(
        this.selectedStart
      ),
      selectedEnd: this.casedashboardService.newFormatedDate(this.selectedEnd),
    };
    this.auditLogDateExportAPI(auditlogDateExportObject);
    this.dialogRef.close();
  }
}
